import React from "react";
import { useMediaQuery } from "react-responsive";
import ContentLoader from 'react-content-loader'
function TransactionLoader() {
  const isLaptop = useMediaQuery({ query: "(max-width: 1020px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div
      className="white full-width"
      style={{
        borderRadius: "12px",
        boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
        padding: "10px 10px 0 10px",
      }}
    >
      <div className={`flex space-between mb-1`}>
        <ContentLoader
          speed={2}
          width={isMobile ? 100 : 200}
          height={24}
          viewBox="0 0 200 24"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="0" rx="3" ry="3" width="140" height="20" />
        </ContentLoader>

        <ContentLoader
          speed={2}
          width={120}
          height={24}
          viewBox="0 0 120 24"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="0" rx="3" ry="3" width="120" height="24" />
        </ContentLoader>
      </div>

      <div style={{ width: "100%", height: 175, position: "relative" }}>
        <ContentLoader
          speed={2}
          width="100%"
          height={175}
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="0" rx="3" ry="3" width="100%" height="175" />
        </ContentLoader>
      </div>
    </div>
  );
}

export default TransactionLoader;
